// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1e28N","main":"style_main__2gVux","button":"style_button__1m6WX","theme_selector_container":"style_theme_selector_container__1EZ3F"};